// export const FETCH_EMP_DISCRIPENCY_REQUEST = "FETCH_EMP_DISCRIPENCY_REQUEST";
// export const FETCH_EMP_DISCRIPENCY_SUCCESS = "FETCH_EMP_DISCRIPENCY_SUCCESS";
// export const FETCH_EMP_DISCRIPENCY_FAILURE = "FETCH_EMP_DISCRIPENCY_FAILURE";

// Add these constants to your existing constants file
export const FETCH_LOCATIONS_REQUEST = 'FETCH_LOCATIONS_REQUEST';
export const FETCH_LOCATIONS_SUCCESS = 'FETCH_LOCATIONS_SUCCESS';
export const FETCH_LOCATIONS_FAILURE = 'FETCH_LOCATIONS_FAILURE';

// Employee Discrepancy Constants
export const FETCH_EMP_DISCRIPENCY_REQUEST = "FETCH_EMP_DISCRIPENCY_REQUEST";
export const FETCH_EMP_DISCRIPENCY_SUCCESS = "FETCH_EMP_DISCRIPENCY_SUCCESS";
export const FETCH_EMP_DISCRIPENCY_FAILURE = "FETCH_EMP_DISCRIPENCY_FAILURE";

// Attendance Summary Constants
export const FETCH_ATTENDANCE_SUMMARY_REQUEST = "FETCH_ATTENDANCE_SUMMARY_REQUEST";
export const FETCH_ATTENDANCE_SUMMARY_SUCCESS = "FETCH_ATTENDANCE_SUMMARY_SUCCESS";
export const FETCH_ATTENDANCE_SUMMARY_FAILURE = "FETCH_ATTENDANCE_SUMMARY_FAILURE";